import React from 'react';
import {useNavigate} from 'react-router-dom';

import {ProfileTabStructure} from 'src/components/profile-tab-structure';
import {ACCOUNT_TABS} from 'src/constants';
import {useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';

import Button from '@pb/kit-component-button';
import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import {noLicensePage, noLicensePageWarningIcon} from './no-license-page.module.styl';

type Props = {
    accountId: number,
};

export const NoLicenseSidebarContent = ({accountId}: Props) => {
    const navigate = useNavigate();
    const {canCreateLicense} = useAdminAccessRight();
    const {licenseCreateOpen} = useEventTracking();

    return (
        <FormSection
            headline="No License"
            info={headlineText => (
                <Item grow={1}>
                    <Group justify="space-between" alignItems="center">
                        {headlineText}
                        {canCreateLicense(accountId) ? (
                            <Button
                                variant="Type.PRIMARY"
                                onClick={() => {
                                    licenseCreateOpen({fromExisting: false});
                                    navigate(
                                        `/profile/account/${accountId}/${ACCOUNT_TABS.CREATE_LICENSE.name}`,
                                    );
                                }}>
                                New License
                            </Button>
                        ) : null}
                    </Group>
                </Item>
            )}>
            <span className={noLicensePage}>
                <Icon className={noLicensePageWarningIcon} type={Icons.ERROR}/>
                {' '}This account has no licenses
            </span>
        </FormSection>
    );
};

export const NoLicensePage = ({accountId}: Props) => (
    <ProfileTabStructure
        width={488}
        minWidth={488}
        sidebar={<NoLicenseSidebarContent accountId={accountId}/>}
    />
);
